<ng-container *ngIf="!env.USE_TAILWIND">
    <div class="block-full-width no-border-radius">
        <h2 [ngClass]="{ 'margin-bottom-10': showRequiredText === true }">
            {{ 'LOGIN_TITLE_YOUR_DETAILS' | translate }}
        </h2>
        <p class="required-text" *ngIf="showRequiredText">{{ 'REQUIRED_FIELDS_FORM_TITLE' | translate }}</p>

        <rwidget-login-email-form
            *ngIf="showSelectedLoginMethodForm('selectedLoginEmail')"
            [captchaToggleAllowed]="captchaToggleAllowed"
            (onLogin)="loginEmail($event)"
            (onForgot)="forgot()">
        </rwidget-login-email-form>

        <ng-container *ngIf="strongAuthOptionsEnabled">
            <hr class="block-form-separator" />
            <div class="block-items-2">
                <h3>{{ 'OR_USE_STRONG_AUTH_LOGIN' | translate }}</h3>

                <div class="items__select-area">
                    <div class="wrapper-items__select-area">
                        <div class="btn btn--selection" (click)="loginIdCard()">
                            {{ 'BTN_ID_CARD_LOGIN' | translate }}
                        </div>
                    </div>
                </div>

                <div class="items__select-area">
                    <div class="wrapper-items__select-area">
                        <div class="btn btn--selection red" (click)="setSelectedLoginMethod('selectedLoginMobileId')">
                            {{ 'BTN_MOBILE_ID_LOGIN' | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</ng-container>

<ng-container *ngIf="env.USE_TAILWIND">
    <div class="mb-10 grid grid-cols-2 gap-4 lg:grid-cols-4" *ngIf="env.AUTH_FEATURES?.length">
        <button
            class="flex min-h-[5rem] flex-col items-center justify-items-center rounded-md border-2 border-solid shadow-[0_0_20px_rgba(0,0,0,0.1)] dark:border-contrast-yellow"
            *ngIf="env.AUTH_FEATURES?.length !== 0"
            [ngClass]="{
                'border-secondary-button text-secondary-button bg-[#F1F8F5] dark:bg-contrast-yellow':
                    selectedLoginMethod === 'selectedLoginEmail'
            }"
            [disabled]="!!verificationCode"
            (click)="setSelectedLoginMethod('selectedLoginEmail')">
            <mat-icon
                class="material-icons-outlined flex flex-1 items-center"
                [ngClass]="{
                    'dark:text-contrast-black': selectedLoginMethod === 'selectedLoginEmail'
                }"
                >email
            </mat-icon>
            <span
                class="flex flex-1 items-center text-primary"
                [ngClass]="
                    selectedLoginMethod === 'selectedLoginEmail'
                        ? 'dark:text-contrast-black'
                        : 'dark:text-contrast-yellow'
                ">
                E-mail
            </span>
        </button>

        <button
            class="flex min-h-[5rem] flex-col items-center justify-items-center rounded-md border-2 border-solid shadow-[0_0_20px_rgba(0,0,0,0.1)] dark:border-contrast-yellow"
            *ngIf="env.AUTH_FEATURES?.includes('ID-CARD')"
            [ngClass]="{
                'border-secondary-button text-secondary-button bg-[#F1F8F5] dark:bg-contrast-yellow':
                    selectedLoginMethod === 'selectedLoginCard'
            }"
            [disabled]="!!verificationCode"
            (click)="loginIdCard()">
            <img class="flex flex-1 items-center" width="32" height="auto" alt="" src="./assets/img/idcard.svg" />
            <span
                class="flex flex-1 items-center text-primary"
                [ngClass]="
                    selectedLoginMethod === 'selectedLoginCard'
                        ? 'dark:text-contrast-black'
                        : 'dark:text-contrast-yellow'
                ">
                {{ 'BTN_ID_CARD_LOGIN' | translate }}
            </span>
        </button>

        <button
            class="flex min-h-[5rem] flex-col items-center justify-items-center rounded-md border-2 border-solid shadow-[0_0_20px_rgba(0,0,0,0.1)] dark:border-contrast-yellow"
            *ngIf="env.AUTH_FEATURES?.includes('MOBILE-ID')"
            [ngClass]="{
                'border-secondary-button text-secondary-button bg-[#F1F8F5] dark:bg-contrast-yellow':
                    selectedLoginMethod === 'selectedLoginMobileId'
            }"
            [disabled]="!!verificationCode"
            (click)="setSelectedLoginMethod('selectedLoginMobileId')">
            <img class="flex flex-1 items-center" width="32" height="auto" alt="" src="./assets/img/mobile-id.svg" />
            <span
                class="flex flex-1 items-center text-primary"
                [ngClass]="
                    selectedLoginMethod === 'selectedLoginMobileId'
                        ? 'dark:text-contrast-black'
                        : 'dark:text-contrast-yellow'
                ">
                {{ 'BTN_MOBILE_ID_LOGIN' | translate }}
            </span>
        </button>

        <button
            class="flex min-h-[5rem] flex-col items-center justify-items-center rounded-md border-2 border-solid shadow-[0_0_20px_rgba(0,0,0,0.1)] dark:border-contrast-yellow"
            *ngIf="env.AUTH_FEATURES?.includes('SMART-ID')"
            [ngClass]="{
                'border-secondary-button text-secondary-button bg-[#F1F8F5] dark:bg-contrast-yellow':
                    selectedLoginMethod === 'selectedLoginSmartId'
            }"
            [disabled]="!!verificationCode"
            (click)="setSelectedLoginMethod('selectedLoginSmartId')">
            <img class="flex flex-1 items-center" width="48" height="auto" alt="" src="./assets/img/smart-id.svg" />
            <span
                class="flex flex-1 items-center text-primary"
                [ngClass]="
                    selectedLoginMethod === 'selectedLoginSmartId'
                        ? 'dark:text-contrast-black'
                        : 'dark:text-contrast-yellow'
                ">
                Smart-ID
            </span>
        </button>

        <button
            class="flex min-h-[5rem] flex-col items-center justify-items-center rounded-md border-2 border-solid shadow-[0_0_20px_rgba(0,0,0,0.1)] dark:border-contrast-yellow"
            *ngIf="env.AUTH_FEATURES?.includes('VIISP')"
            [ngClass]="{
                'border-secondary-button text-secondary-button bg-[#F1F8F5] dark:bg-contrast-yellow':
                    selectedLoginMethod === 'selectedLoginViisp'
            }"
            (click)="setSelectedLoginMethod('selectedLoginViisp')">
            <img class="my-1 h-8 w-8" alt="VIISP" src="./assets/img/viisp.png" />
            <span
                class="flex flex-1 items-center text-primary"
                [ngClass]="
                    selectedLoginMethod === 'selectedLoginViisp'
                        ? 'dark:text-contrast-black'
                        : 'dark:text-contrast-yellow'
                ">
                VIISP
            </span>
        </button>

        <button
            class="flex min-h-[5rem] flex-col items-center justify-items-center rounded-md border-2 border-solid shadow-[0_0_20px_rgba(0,0,0,0.1)] dark:border-contrast-yellow"
            *ngIf="env.AUTH_FEATURES?.includes('FREJA')"
            [disabled]="!!verificationCode"
            (click)="onFrejaAuthenticationClick()">
            <img
                class="flex flex-1 items-center"
                width="80"
                height="auto"
                alt="Freja eID"
                src="./assets/img/freja-eid-logo.svg" />
            <span class="flex flex-1 items-center text-primary dark:text-contrast-yellow">Freja eID</span>
        </button>
    </div>

    <rwidget-login-email-form
        *ngIf="showSelectedLoginMethodForm('selectedLoginEmail')"
        [captchaToggleAllowed]="captchaToggleAllowed"
        (onLogin)="loginEmail($event)"
        (onForgot)="forgot()">
    </rwidget-login-email-form>

    <rwidget-login-mobileid-form
        *ngIf="showSelectedLoginMethodForm('selectedLoginMobileId')"
        (onLogin)="loginMobileId($event)">
    </rwidget-login-mobileid-form>

    <rwidget-login-smartid-form
        *ngIf="showSelectedLoginMethodForm('selectedLoginSmartId')"
        (onLogin)="loginSmartId($event)">
    </rwidget-login-smartid-form>

    <rwidget-login-viisp-form *ngIf="showSelectedLoginMethodForm('selectedLoginViisp')"> </rwidget-login-viisp-form>

    <rwidget-challenge-message [verificationCode]="verificationCode" (onCancel)="cancelChallengePolling()">
    </rwidget-challenge-message>
</ng-container>
